import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isOnline } from '../offline/platform';

const PrivateRoute = ({ children }) => {
  const { currentUser, isEmailVerified, logout } = useAuth();

  // Offline, Firebase may not be able to confirm the session. Nothing here
  // may sign the user out or bounce them to a login page they cannot use:
  // the downloaded library works without either.
  if (!currentUser) {
    return <Navigate to={isOnline() ? '/auth' : '/downloads'} replace />;
  }

  if (!isEmailVerified) {
    if (!isOnline()) return <Navigate to="/downloads" replace />;
    // Sign out and redirect to auth page if email is not verified
    logout();
    return <Navigate to="/auth" />;
  }

  return children;
};

export default PrivateRoute;